import { useEffect, useState, useCallback } from 'react'
import { Bell, Search, Star, Archive, Trash2, CheckCheck, Inbox, Filter } from 'lucide-react'
import api from '../api/client'
import Loader from '../components/Loader'
import Pagination from '../components/Pagination'
import { confirmModal } from '../components/ui'

const CATS = [
  { v: '', label: 'Todas' }, { v: 'financeiro', label: 'Financeiro' }, { v: 'rede', label: 'Rede' },
  { v: 'loja', label: 'Loja' }, { v: 'carreira', label: 'Carreira' }, { v: 'sistema', label: 'Sistema' },
  { v: 'personalizada', label: 'Comunicados' },
]
const CAT_CLS = {
  financeiro: 'bg-emerald-100 text-emerald-700', rede: 'bg-primary-100 text-primary-700',
  loja: 'bg-accent-100 text-accent-700', carreira: 'bg-violet-100 text-violet-700',
  sistema: 'bg-sky-100 text-sky-700', personalizada: 'bg-neutral-100 text-neutral-600',
}
const fmt = (v) => (v ? new Date(v).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '')

export default function Notificacoes() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [total, setTotal] = useState(0)
  const [cat, setCat] = useState('')
  const [aba, setAba] = useState('todas')       // todas | nao_lidas | favoritos | arquivadas
  const [busca, setBusca] = useState('')
  const [deb, setDeb] = useState('')

  useEffect(() => { const t = setTimeout(() => setDeb(busca), 300); return () => clearTimeout(t) }, [busca])

  const load = useCallback(() => {
    setLoading(true)
    const params = { page, limit: 20 }
    if (cat) params.categoria = cat
    if (aba === 'nao_lidas') params.apenas_nao_lidas = true
    if (aba === 'favoritos') params.favoritos = true
    if (aba === 'arquivadas') params.arquivadas = true
    if (deb) params.busca = deb
    api.get('/notificacoes', { params }).then((r) => { setRows(r.data.data || []); setTotal(r.data.total || 0); setPages(Math.max(1, Math.ceil((r.data.total || 0) / 20))) })
      .catch(() => setRows([])).finally(() => setLoading(false))
  }, [page, cat, aba, deb])
  useEffect(() => { load() }, [load])

  const marcarLida = (id) => api.put(`/notificacoes/${id}/marcar-lida`).then(load).catch(() => {})
  const marcarTodas = () => api.put('/notificacoes/marcar-todas-lidas').then(load).catch(() => {})
  const favoritar = (id) => api.put(`/notificacoes/${id}/favoritar`).then(load).catch(() => {})
  const arquivar = (id) => api.put(`/notificacoes/${id}/arquivar`).then(load).catch(() => {})
  const excluir = async (id) => { if (await confirmModal('Excluir esta notificação?', { title: 'Excluir', okLabel: 'Excluir' })) api.delete(`/notificacoes/${id}`).then(load).catch(() => {}) }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h1 className="text-xl sm:text-2xl font-heading font-extrabold text-graphite flex items-center gap-2"><Bell size={24} className="text-accent-500" /> Central de Notificações</h1>
          <p className="text-sm text-neutral-500 mt-1">Suas notificações — financeiro, rede, loja, campanhas e comunicados</p>
        </div>
        <button onClick={marcarTodas} className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-700 border border-accent-200 rounded-xl px-3 py-2 hover:bg-accent-50"><CheckCheck size={15} /> Marcar todas como lidas</button>
      </div>

      <div className="bg-white rounded-2xl border border-neutral-200 shadow-sm p-3 flex flex-wrap gap-3 items-center">
        <div className="flex gap-1 bg-neutral-100 rounded-xl p-1">
          {[['todas', 'Todas'], ['nao_lidas', 'Não lidas'], ['favoritos', 'Favoritos'], ['arquivadas', 'Arquivadas']].map(([v, l]) => (
            <button key={v} onClick={() => { setAba(v); setPage(1) }} className={`px-3 py-1.5 rounded-lg text-xs font-semibold ${aba === v ? 'bg-white shadow text-accent-700' : 'text-neutral-500'}`}>{l}</button>
          ))}
        </div>
        <div className="flex-1 min-w-[200px] relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
          <input value={busca} onChange={(e) => { setBusca(e.target.value); setPage(1) }} placeholder="Pesquisar..." className="w-full pl-9 pr-3 py-2 rounded-xl border border-neutral-200 text-sm outline-none focus:border-accent-400" />
        </div>
        <div className="flex items-center gap-1.5 text-neutral-500"><Filter size={14} />
          <select value={cat} onChange={(e) => { setCat(e.target.value); setPage(1) }} className="border border-neutral-200 rounded-xl px-2 py-2 text-sm outline-none">
            {CATS.map((c) => <option key={c.v} value={c.v}>{c.label}</option>)}
          </select>
        </div>
      </div>

      {loading ? <div className="flex justify-center py-20"><Loader text="Carregando..." /></div> : (
        <div className="space-y-2">
          {rows.length === 0 ? (
            <div className="text-center py-16 text-neutral-400 bg-white rounded-2xl border border-neutral-200"><Inbox size={40} className="mx-auto mb-2 opacity-30" /><p>Nenhuma notificação aqui</p></div>
          ) : rows.map((n) => (
            <div key={n.id} onClick={() => !n.lida && marcarLida(n.id)}
              className={`bg-white rounded-2xl border shadow-sm p-4 flex gap-3 cursor-pointer transition ${n.lida ? 'border-neutral-100' : 'border-accent-200 bg-accent-50/20'}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  {!n.lida && <span className="w-2 h-2 rounded-full bg-accent-500 flex-shrink-0" />}
                  <p className="font-semibold text-graphite text-sm">{n.titulo}</p>
                  {n.categoria && <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${CAT_CLS[n.categoria] || 'bg-neutral-100 text-neutral-600'}`}>{n.categoria}</span>}
                  {n.prioridade === 'alta' && <span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded-full bg-red-100 text-red-700">Alta</span>}
                </div>
                {n.subtitulo && <p className="text-xs text-neutral-500 mt-0.5">{n.subtitulo}</p>}
                {n.mensagem && <p className="text-sm text-neutral-600 mt-1 line-clamp-3 whitespace-pre-line">{n.mensagem}</p>}
                <p className="text-[11px] text-neutral-400 mt-1">{fmt(n.created_at)}</p>
              </div>
              <div className="flex flex-col gap-1 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                <button onClick={() => favoritar(n.id)} title="Favoritar" className={`p-1.5 rounded-lg hover:bg-amber-50 ${n.favorito ? 'text-amber-500' : 'text-neutral-300'}`}><Star size={16} fill={n.favorito ? 'currentColor' : 'none'} /></button>
                <button onClick={() => arquivar(n.id)} title="Arquivar" className="p-1.5 rounded-lg hover:bg-neutral-100 text-neutral-400"><Archive size={16} /></button>
                <button onClick={() => excluir(n.id)} title="Excluir" className="p-1.5 rounded-lg hover:bg-red-50 text-neutral-400 hover:text-red-500"><Trash2 size={16} /></button>
              </div>
            </div>
          ))}
          {total > 20 && <div className="bg-white rounded-2xl border border-neutral-200 px-4 py-3"><Pagination page={page} pages={pages} total={total} pageSize={20} onPage={setPage} onPageSize={() => {}} /></div>}
        </div>
      )}
    </div>
  )
}
